// extracted by mini-css-extract-plugin
export default {"PriceList":"PriceList_PriceList__8RKZ8","PriceList__new":"PriceList_PriceList__new__dD1L2","PriceList__table":"PriceList_PriceList__table__LIlxD"};